
import { Routes, Route } from "react-router-dom"; // Importa componentes necesarios para la navegación entre páginas
import Cards from "./Sounds/Cards"; // Importa el componente Cards
// import Hanoi from "./Sounds/Hanoi"; // Importa el componente Hanoi
// import Frieze from "./Sounds/Frieze"; // Importa el componente Frieze
import Koch from "./Sounds/Koch"; // Importa el componente Koch
import Hilbert from "./Sounds/Hilbert"; // Importa el componente Hilbert
import LSystems from "./Sounds/LSystems"; // Importa el componente LSystems
import BinauralKoch from "./Sounds/BinauralKoch"; // Importa el componente BinauralKoch
import Tiling from "./Sounds/Tiling"; // Importa el componente Tiling
import Rose from "./Sounds/Rose"; // Importa el componente Rose
import Soundscape from "./Sounds/Soundscape"; // Importa el componente Soundscape
import BioChemical from "./Sounds/BioChemical"; // Importa el componente BioChemical

export default function Sounds() {
  return (
    <>
      <Routes>
        {/* Define las rutas que corresponden a diferentes componentes */}
        <Route path = "/" element= {<Cards/>}/> {/* Ruta para la página principal, carga el componente Cards */}
        <Route path = "/koch" element= <Koch/>/> {/* Ruta para la página de Koch */}
        <Route path = "/tiling" element= <Tiling/>/> {/* Ruta para la página de Tiling */}
        <Route path = "/rose" element= <Rose/>/> {/* Ruta para la página de Rose */}
        <Route path = "/soundscape" element= <Soundscape/>/> {/* Ruta para la página de Soundscape */}
        <Route path = "/hilbert" element= <Hilbert/>/> {/* Ruta para la página de Hilbert */}
        <Route path = "/l-systems" element= <LSystems/>/> {/* Ruta para la página de LSystems */}
        <Route path = "/binaural-koch" element= <BinauralKoch/>/> {/* Ruta para la página de BinauralKoch */}
        <Route path = "/bio-chemical" element= <BioChemical/>/> {/* Ruta para la página de BioChemical */}
      </Routes>
    </>
  );
}

